import { render, staticRenderFns } from "./folder-menu.vue?vue&type=template&id=5435f1aa"
import script from "./folder-menu.vue?vue&type=script&lang=js"
export * from "./folder-menu.vue?vue&type=script&lang=js"
import style0 from "./folder-menu.vue?vue&type=style&index=0&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports